import validate from 'validate.js';

const constraints = {
    full_name: {
	presence: { 
	    message: 'napiši ime in priimek'
	}
    },
    description: {
	presence: { 
	    message: 'napiši besedilo'
	}
    },
    email: {
	email: {
	    message: 'napiši vašo email'
	},
	presence: { 
	    message: 'napiši vašo email'
	}
    },

}

const EventValidator = ( fields ) => {
    var validations= validate(fields, constraints, {fullMessages: false}) || {};
 
    return validations
}

export default EventValidator ;



// WEBPACK FOOTER //
// ./src/validators/ContactValidator.js